import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { ArrowRightIcon } from "../../../assets/ArrowRight";
import { DeliveryIcon } from "../../../assets/Delivery";
// import { ForkIcon } from "../../../assets/Fork";
// import {
//   Tabs,
//   TabsList,
//   TabsTrigger,
//   TabsContent,
// } from "../../../components/ui/tabs";

import { NotificationIcon } from "../../../assets/Notification";
import { SearchIcon } from "../../../assets/Search";

import { Card } from "../../../components/ui/card";
import { useIntersectionObserver } from "usehooks-ts";


import { impactOccuer, selectionChanged } from "../../../utils/hapticEvents";

import { CategoryCard } from "./component/CategoryCard";

import { cn } from "../../../lib/utils";
import { BackButtonHide } from "../../../utils/BackButton";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { CategoryCardSkeleton } from "./component/CategoriesCarSekelton";
import { useSelector } from "react-redux";

import { LanguageSwitcher } from "../../../components/LanguageSwitcher";
import { LoyaltyCard } from "../../loyalty/ui/LoyaltyCard";
import { useChangeLanguage, type AppLanguage } from "../../../lib/useChangeLanguage";
import { useGetAddresses } from "../../addresses/services/getAddresses";
import { useGetMenu } from "../services/getMenu";
import { FoodHomeCard } from "../../pickup/ui/component/FoodCard";
import { PromotionCountdown } from "./component/PromotionCountdown";
import { userInfo } from "../../../store/selectors/user";

import { AuthDrawer } from "../../../components/AuthDrawer";
import { useUnreadNotificationsCount } from "../../notification/services/getNotifications";
import { useGetBanners } from "../services/getBanners";

import { normalizeId } from "../../../utils/notmalizeStr";
import { truncate } from "../../../utils/truncate";
import { FoodSectionSkleton } from "../../../components/FoodCardSkeleton";
import { LogoRewards } from "../../../assets/LogoRewards";
import { localized, useAppLanguage } from "../../../utils/localized";
import { userLocation } from "../../../store/selectors/location";

import {
  Drawer,
  DrawerContent,
  DrawerTitle,
} from "../../../components/ui/drawer";
import { useAskTelegramLocation } from "../../../lib/useAskTelegramLocation";
import { userSavedAddresses } from "../../../store/selectors/userAddresses";
import { getDistanceInMeters } from "../../../utils/distance";
import { DeliveryDetail } from "../../../store/selectors/delivery";
// import { getPickup } from "../../../store/selectors/pickup";
// import { fulfillmentMode } from "../../../store/selectors/fulfillment";
// import { setFulfillmentMode } from "../../../store/slices/fulfillment";
import { requestCartLocationGate } from "../../../lib/cartLocationGate";
import { formatDeliveryTime } from "../../../utils/deliveryTimeConverter";
import { BannerCarousel } from "../../../components/Banners";
import { XIcon } from "../../../assets/X";
import { CheckIcon } from "../../../assets/Check";
import { Separator } from "../../../components/ui/separator";
import { LANGUAGE_DRAWER_LABELS } from "../../../utils/languageLabels";
import { useGetNearesBranch } from "../../addresses/services/getNearBranch";
import { useGetDeliveryDetail } from "../../basket/services/getDeliveryDetail";
import { selectBasketItems, selectTotalPrice } from "@/store/selectors/basket";
import { useClearBasket } from "../../basket/services/clearBasket";
import { ReplaceUnavailableBar } from "../../../components/ReplaceUnavailableBar";
import { custonSooner } from "../../../components/CustopmSooner";
import { UnavailableItemsDrawer } from "../../../components/UnavailableItemsDrawer";
import { useFooterTopSlot } from "../../../layout/main";
import { BasketItem } from "../../../store/slices/basketSlice";
import {
  clearReplacementLog,
  getReplacementLog,
  ReplacementEntry,
} from "../../basket/libs/replacementLog";
// Скрыты вместе с промо-блоком на главной (см. ниже).
// import { ActionCard } from "./component/ActionCard";
// import { PromoCard } from "./component/PromoCard";
import { Stories } from "./component/Stories";

// Куда встаёт верх секции при скролле к категории: под липкую шапку с
// панелью категорий. Та же линия решает, какая категория активна.
const CATEGORY_SCROLL_OFFSET = 160;

export const Home = () => {
  useAskTelegramLocation();
  const { t } = useTranslation();
  BackButtonHide();
  const [scrolled, setScrolled] = useState(false);
  const [shrinkProgress, setShrinkProgress] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    sessionStorage.setItem("lastHomeVisit", Date.now().toString());

    return () => {
      const lastVisit = sessionStorage.getItem("lastHomeVisit");
      const now = Date.now();
      const fiveMinutes = 5 * 60 * 1000;

      if (lastVisit && now - parseInt(lastVisit) > fiveMinutes) {
        sessionStorage.removeItem("homeScrollPosition");
      }
    };
  }, []);

  const [open, setIsOpen] = useState(false);
  // Гость нажал «указать адрес»: сначала шторка входа, а после успеха —
  // сам экран адреса. Адрес принадлежит аккаунту, без него сохранять некуда.
  const [pendingAddressRedirect, setPendingAddressRedirect] = useState(false);
  // То же для колокольчика: уведомления есть только у аккаунта, гостю — вход,
  // а после него сразу экран уведомлений.
  const [pendingNotificationRedirect, setPendingNotificationRedirect] =
    useState(false);
  const unreadNotifications = useUnreadNotificationsCount();
  // The auth drawer is shared with the generic "log in" banner, so remember
  // that this particular login was started from the pickup row.
  // const [pendingPickupRedirect, setPendingPickupRedirect] = useState(false);
  // const deliveryTab = useSelector(fulfillmentMode);
  const [languageDrawerOpen, setLanguageDrawerOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState(
    localStorage.getItem("language") || "uz",
  );
  const [realAddresses, setRealAddresses] = useState(
    sessionStorage.getItem("real") !== "true",
  );
  const savedAddresses = useSelector(userSavedAddresses);
  const { latitude: lat, longitude: lng } = useSelector(userLocation);
  const user = useSelector(userInfo);
  const lang = useAppLanguage();
  const { deliveryTime } = useSelector(DeliveryDetail);
  // const pickup = useSelector(getPickup);

  const { addresses, isLoading: isLoadingAddresses } = useGetAddresses();
  const { nearest, isBranchResolved } = useGetNearesBranch();
  // Пока филиал не определён по адресу/геолокации, подборки запрашиваем без
  // branch_id — иначе ушёл бы филиал, вычисленный от центра города.
  const contentBranchId = isBranchResolved ? nearest?.branch_id : undefined;
  const { banners, isLoading: isLoadingBanners } =
    useGetBanners(contentBranchId);
  const { menu, isLoading: isLoadingMenu } = useGetMenu(nearest?.branch_id);
  const totalPrice = useSelector(selectTotalPrice);
  useGetDeliveryDetail(totalPrice, nearest?.branch_id);

  // --- "replace this unavailable item" bar -----------------------------------
  const basketItems = useSelector(selectBasketItems);
  const { clearBasket } = useClearBasket();
  const [replacingCartKey, setReplacingCartKey] = useState<string | null>(() =>
    sessionStorage.getItem("replacingCartKey"),
  );
  const [unavailableListOpen, setUnavailableListOpen] = useState(false);
  const [replacements, setReplacements] = useState<ReplacementEntry[]>(() =>
    getReplacementLog(),
  );

  // Re-read on every arrival: the key is written by the cart right before it
  // navigates here, so a mount-only read would miss repeat visits.
  useEffect(() => {
    setReplacingCartKey(sessionStorage.getItem("replacingCartKey"));
  }, [location.key]);

  const unavailableItems = useMemo(
    () => basketItems.filter((item) => !item.isAvailable),
    [basketItems],
  );

  // Swaps are written to the log from inside the add-to-basket flow, so the
  // basket changing is the signal that there may be a new one to pick up.
  useEffect(() => {
    setReplacements(getReplacementLog());
  }, [basketItems, unavailableListOpen]);

  // Only the item the user explicitly picked; with none chosen the bar shows a
  // summary of everything instead of guessing.
  const replacingItem = useMemo(
    () => unavailableItems.find((item) => item.cartKey === replacingCartKey),
    [unavailableItems, replacingCartKey],
  );

  // Once an armed item is dealt with (replaced or removed), it drops out of
  // unavailableItems and this key stops matching anything. Pick up the next
  // unavailable item automatically so working through several of them
  // doesn't mean going back into the drawer after each one — but only if a
  // key was armed in the first place; with none set the bar still shows the
  // summary instead of guessing which item to jump to.
  useEffect(() => {
    if (!replacingCartKey) return;
    if (unavailableItems.some((item) => item.cartKey === replacingCartKey))
      return;

    const next = unavailableItems[0]?.cartKey ?? null;

    if (next) sessionStorage.setItem("replacingCartKey", next);
    else sessionStorage.removeItem("replacingCartKey");

    setReplacingCartKey(next);
  }, [unavailableItems, replacingCartKey]);

  const [activeCategory, setActiveCategory] = useState("");
  const activeCategoryRef = useRef("");
  const categoriesContainerRef = useRef<HTMLDivElement>(null);
  // После тапа по категории подсветка закреплена за ней, пока пользователь
  // сам не начнёт скроллить. Снимать замок по таймеру или по достижению
  // цели нельзя: плавный скролл бывает дольше секунды, а ленивые картинки
  // сдвигают секции по ходу — и подсветка успевала «отпрыгнуть» на соседнюю
  // категорию, прежде чем вернуться. Скролл по тапу и так заканчивается на
  // выбранной категории; пересчитывать её по позиции незачем.
  const categoryScrollLockRef = useRef(false);

  const scrollCategoryButtonIntoView = (categoryName: string) => {
    if (!categoriesContainerRef.current) return;

    const button = categoriesContainerRef.current.querySelector(
      `div[data-category="${categoryName}"]`,
    ) as HTMLElement;

    if (button) {
      const container = categoriesContainerRef.current;
      const containerWidth = container.offsetWidth;
      const buttonLeft = button.offsetLeft ?? 0;
      const buttonWidth = button.offsetWidth ?? 0;

      const scrollPosition = buttonLeft - containerWidth / 2 + buttonWidth / 2;

      container.scrollTo({ left: scrollPosition, behavior: "smooth" });
    }
  };

  // Единая точка смены подсветки: и по тапу, и по скроллу. Без сравнения с
  // текущим значением каждый тик скролла заново прокручивал бы панель.
  const activateCategory = (normalized: string) => {
    if (activeCategoryRef.current === normalized) return;

    activeCategoryRef.current = normalized;
    setActiveCategory(normalized);
    scrollCategoryButtonIntoView(normalized);
  };

  const scrollToCategory = (categoryName: string) => {
    const normalized = normalizeId(categoryName);
    activateCategory(normalized);

    const element = document.getElementById(`category-${normalized}`);
    const scrollContainer = document.getElementById("scrollable");

    if (!element || !scrollContainer) return;

    const elementTop =
      element.offsetTop - scrollContainer.offsetTop - CATEGORY_SCROLL_OFFSET;

    categoryScrollLockRef.current = true;
    scrollContainer.scrollTo({ top: elementTop, behavior: "smooth" });
  };

  // --- "replace unavailable items" bar + list --------------------------------

  // The summary is a receipt, not a task — dismissing it drops the log and
  // with it the bar, once there's nothing unavailable left to deal with.
  const handleDismissReplacements = () => {
    clearReplacementLog();
    setReplacements([]);
  };

  const handleReplaceItem = (item: BasketItem) => {
    sessionStorage.setItem("replacingCartKey", item.cartKey);
    setReplacingCartKey(item.cartKey);
    setUnavailableListOpen(false);

    const category = menu?.find(
      (entry) => String(entry.id) === String(item.category_id),
    );
    if (!category) return;

    const categoryName =
      localized(lang, {
        ru: category.category.title,
        uz: category.category.title_uz,
        en: category.category.title_en,
      });

    // Let the sheet finish closing before scrolling, otherwise the drawer's
    // scroll lock swallows it.
    setTimeout(() => scrollToCategory(categoryName), 300);
  };

  // Removals apply on tap — no staging, no confirmation step. Always one
  // `clearBasket` call per action: removing keys in a loop ran each removal
  // against the same basket snapshot and wrote the whole basket back every
  // time, so every removal but the last was undone as soon as the basket query
  // re-hydrated redux from storage.
  const applyRemoval = async (removedCartKeys: string[]) => {
    if (!removedCartKeys.length) return;

    await clearBasket({ cartKeys: removedCartKeys });

    const remainingUnavailable = unavailableItems.filter(
      (item) => !removedCartKeys.includes(item.cartKey),
    );

    // Nothing left to deal with — close up and start a fresh swap log.
    if (!remainingUnavailable.length) {
      setUnavailableListOpen(false);

      if (!replacements.length) {
        clearReplacementLog();
        setReplacements([]);
      }
    }
  };

  const handleRemoveUnavailable = (item: BasketItem) =>
    applyRemoval([item.cartKey]);

  const handleRemoveAllUnavailable = async () => {
    const removed = unavailableItems.map((item) => item.cartKey);

    await applyRemoval(removed);

    if (removed.length > 1) {
      custonSooner.success(t("removed-count", { count: removed.length }));
    }
  };

  useFooterTopSlot(
    unavailableItems.length || replacements.length ? (
      <ReplaceUnavailableBar
        items={unavailableItems}
        replacements={replacements}
        activeItem={replacingItem}
        onOpen={() => setUnavailableListOpen(true)}
        onRemove={handleRemoveUnavailable}
        onDismiss={handleDismissReplacements}
      />
    ) : null,
  );

  // Активная категория — по положению скролла, а не по IntersectionObserver.
  // У наблюдателя была полоса «-50% … -20%» окна: после тапа секция вставала
  // под шапку (160px), в полосу попадала уже следующая — и подсветка
  // перескакивала с выбранной на соседнюю; при ручном скролле срабатывали
  // сразу несколько секций в произвольном порядке. Здесь правило одно:
  // активна последняя секция, чей верх прошёл линию под шапкой — та же
  // линия, к которой скроллит тап, поэтому оба пути сходятся.
  useEffect(() => {
    const scrollElement = document.getElementById("scrollable");
    if (!scrollElement || !menu?.length) return;

    const ids = menu.map((item) =>
      normalizeId(
        localized(lang, {
          ru: item.category.title,
          uz: item.category.title_uz,
          en: item.category.title_en,
        }),
      ),
    );

    let frame = 0;

    const updateActiveCategory = () => {
      frame = 0;

      if (categoryScrollLockRef.current) return;

      const line = scrollElement.scrollTop + CATEGORY_SCROLL_OFFSET + 1;
      const atBottom =
        scrollElement.scrollTop + scrollElement.clientHeight >=
        scrollElement.scrollHeight - 2;

      // У последней категории может не хватать высоты, чтобы дойти до линии —
      // внизу списка подсвечиваем её без условий.
      let active = atBottom ? ids[ids.length - 1] : ids[0];

      if (!atBottom) {
        for (const id of ids) {
          const element = document.getElementById(`category-${id}`);
          if (!element) continue;
          if (element.offsetTop - scrollElement.offsetTop <= line) active = id;
          else break;
        }
      }

      activateCategory(active);
    };

    const onScroll = () => {
      if (frame) return;
      frame = requestAnimationFrame(updateActiveCategory);
    };

    // Жест пользователя снимает замок тапа. touchstart приходит раньше click
    // по карточке категории, так что тап по следующей категории сначала
    // снимет старый замок, а потом поставит свой.
    const onUserScrollIntent = () => {
      categoryScrollLockRef.current = false;
    };
    const intentEvents = ["touchstart", "wheel", "pointerdown"] as const;

    scrollElement.addEventListener("scroll", onScroll, { passive: true });
    intentEvents.forEach((type) =>
      scrollElement.addEventListener(type, onUserScrollIntent, {
        passive: true,
      }),
    );
    updateActiveCategory();

    return () => {
      scrollElement.removeEventListener("scroll", onScroll);
      intentEvents.forEach((type) =>
        scrollElement.removeEventListener(type, onUserScrollIntent),
      );
      if (frame) cancelAnimationFrame(frame);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, menu]);

  useEffect(() => {
    if (!menu || menu.length === 0) return;
    const categoryId = sessionStorage.getItem("scrollToCategory");
    console.log("[Home] scrollToCategory effect", {
      categoryId,
      menuLength: menu.length,
      pathname: location.pathname,
    });
    if (!categoryId) return;
    sessionStorage.removeItem("scrollToCategory");

    const category = menu.find((item) => String(item.id) === categoryId);
    console.log("[Home] found category", category);

    // Диплинк вёл в категорию, которой в меню филиала нет, — говорим об этом
    // и оставляем пользователя на главной, он уже здесь.
    if (!category) {
      custonSooner.error(t("product-unavailable"));
      return;
    }

    const categoryName =
      localized(lang, {
        ru: category.category.title,
        uz: category.category.title_uz,
        en: category.category.title_en,
      });
    console.log("[Home] scrolling to", categoryName);
    setTimeout(() => scrollToCategory(categoryName), 300);
  }, [menu, lang, location.key]);

  const { ref } = useIntersectionObserver({
    threshold: 0.5,
  });

  const categorySentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollElement = document.getElementById("scrollable");

    if (!scrollElement) return;

    const SHRINK_RANGE = 64; // px of scroll over which the category bar shrinks

    const handleScroll = (isRealScrollEvent: boolean) => {
      const scrollTop = scrollElement.scrollTop;

      const platform = window.Telegram?.WebApp?.platform;
      const isMobileDevice = platform === "ios" || platform === "android";
      const stickyHeaderHeight = isMobileDevice ? 60 : 64;

      // Measure the sentinel's position live on every scroll tick instead of caching an
      // "initial" offset — a cached value goes stale (and makes it flicker) once async
      // content above it (stories, banners) finishes loading and shifts the layout.
      const sentinelTop =
        categorySentinelRef.current?.getBoundingClientRect().top ?? Infinity;
      const scrollableTop = scrollElement.getBoundingClientRect().top;
      const relativeTop = sentinelTop - scrollableTop;

      // Drive the shrink directly off scroll position (not a fixed-duration CSS
      // transition) so it tracks the finger 1:1 with zero lag — a duration-based
      // transition has to "catch up" to wherever the scroll already is, which is what
      // reads as jerky/stuttery. Progress goes 0 (full size) -> 1 (fully shrunk & stuck).
      const start = stickyHeaderHeight + SHRINK_RANGE;
      const end = stickyHeaderHeight;
      const progress = Math.min(
        1,
        Math.max(0, (start - relativeTop) / (start - end)),
      );

      setShrinkProgress(progress);
      setScrolled(progress >= 1);

      // Only persist on genuine scroll events — the one-off priming call below always
      // runs at mount time, before the scroll-restoration effect has had a chance to
      // apply the previously saved position, and would otherwise stomp it back to 0.
      // Второе условие — про уход с главной. Роутер меняет URL раньше, чем
      // React подменяет содержимое #scrollable, и в момент подмены высокая
      // главная сменяется коротким экраном: браузер зажимает scrollTop к нулю
      // и стреляет scroll-событием. Без проверки пути мы бы сохранили этот ноль
      // и вернули пользователя в самое начало.
      if (isRealScrollEvent && window.location.pathname === "/") {
        sessionStorage.setItem("homeScrollPosition", scrollTop.toString());
      }
    };

    const onScroll = () => handleScroll(true);

    scrollElement.addEventListener("scroll", onScroll);
    handleScroll(false);

    return () => {
      scrollElement.removeEventListener("scroll", onScroll);
    };
  }, []);

  // Restore where the user left off when coming back to Home (e.g. after opening a
  // product and pressing back). A single one-shot scrollTop set right after mount isn't
  // enough — banners/images are still loading at that point, so the page is shorter
  // than its final height and the browser clamps the scroll back down near the top.
  // Keep re-applying it via ResizeObserver until the content has grown tall enough to
  // actually hold that position, for a bounded window after mount.
  useEffect(() => {
    if (isLoadingMenu || !menu || menu.length === 0) return;

    const scrollElement = document.getElementById("scrollable");
    const savedScrollPosition = sessionStorage.getItem("homeScrollPosition");
    const targetScrollTop = savedScrollPosition
      ? parseInt(savedScrollPosition, 10)
      : NaN;

    if (!scrollElement || isNaN(targetScrollTop) || targetScrollTop <= 0)
      return;

    let userTookOver = false;
    let lastApplied = -1;

    const applyIfPossible = () => {
      if (userTookOver) return;
      const maxScrollTop =
        scrollElement.scrollHeight - scrollElement.clientHeight;
      if (
        maxScrollTop >= targetScrollTop &&
        scrollElement.scrollTop !== targetScrollTop
      ) {
        scrollElement.scrollTop = targetScrollTop;
        lastApplied = targetScrollTop;
      }
    };

    // If the user starts scrolling on their own before we've finished restoring,
    // stop re-applying our value so we don't fight their input.
    const handleUserScroll = () => {
      if (
        lastApplied !== -1 &&
        Math.abs(scrollElement.scrollTop - lastApplied) > 2
      ) {
        userTookOver = true;
      }
    };

    applyIfPossible();
    scrollElement.addEventListener("scroll", handleUserScroll);

    const observer = new ResizeObserver(applyIfPossible);
    observer.observe(scrollElement);

    const stopTimer = setTimeout(() => observer.disconnect(), 2000);

    return () => {
      observer.disconnect();
      clearTimeout(stopTimer);
      scrollElement.removeEventListener("scroll", handleUserScroll);
    };
  }, [isLoadingMenu, menu]);

  const userAddress = isLoadingAddresses
    ? null
    : addresses.find(
        (address) => String(address._id) === String(savedAddresses),
      );

  const distance = getDistanceInMeters(
    userAddress?.location?.lat,
    userAddress?.location?.lon,
    lng!,
    lat!,
  );

  useEffect(() => {
    if (
      user.isAuth &&
      addresses.length > 0 &&
      userAddress &&
      sessionStorage.getItem("real") !== "true"
    ) {
      if (distance > 50) {
        setRealAddresses(true);
      }
    }
  }, [addresses.length, distance, lat, lng, user.isAuth, userAddress]);

  useEffect(() => {
    const hasChosenLanguage = localStorage.getItem("hasChosenLanguage");
    if (!hasChosenLanguage) {
      setLanguageDrawerOpen(true);
    }
  }, []);

  const applyLanguage = useChangeLanguage();
  const changeLanguage = () => {
    applyLanguage(selectedLang as AppLanguage);
    setLanguageDrawerOpen(false);
  };

  const platform = window.Telegram?.WebApp?.platform;
  const isMobile = platform === "ios" || platform === "android";

  return (
    <div className="flex flex-col gap-[10px] flex-1 pb-10">
      {/* Светлая шапка по макету: логотип слева, справа кнопка поиска и
          язык. Высота прежняя (36px + отступы) — на неё завязан расчёт
          сжатия панели категорий (stickyHeaderHeight). */}
      <div className="flex fixed top-safe-top z-50 flex-row items-center gap-3 px-4 bg-fill-background pt-3 pb-3 justify-between w-full">
        {/* Логотип широкий: на узком экране он сжимается (min-w-0) с
            сохранением пропорций, а кнопки справа — нет, поэтому не
            перекрываются. До 22px в высоту, как прежний. */}
        <LogoRewards className="h-[22px] w-auto min-w-0 shrink" />
        <div className="flex shrink-0 flex-row items-center gap-2">
          <button
            type="button"
            aria-label={t("search")}
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-white"
            onClick={() => {
              impactOccuer("soft");
              navigate("/search");
            }}
          >
            <SearchIcon className="h-5 w-5 text-text-primary" />
          </button>
          <LanguageSwitcher />
          {/* Колокольчик — справа от языка, по макету: без подложки. 36px, а не 37 из
              макета: на высоту шапки завязан stickyHeaderHeight.
              Бейдж — число непрочитанных: 18px с обводкой 2px цветом шапки,
              у правого верхнего края колокольчика, как в макете. Иконка
              отцентрована (см. NotificationIcon), поэтому бейдж чуть выходит
              за кнопку вправо-вверх. */}
          <button
            type="button"
            aria-label={t("notifications")}
            className="relative h-9 w-9 shrink-0"
            onClick={() => {
              impactOccuer("soft");

              if (!user.isAuth) {
                setPendingNotificationRedirect(true);
                setIsOpen(true);
                return;
              }

              navigate("/notification");
            }}
          >
            <NotificationIcon className="h-9 w-9 text-text-primary" />
            {unreadNotifications > 0 ? (
              <span className="absolute left-[19px] -top-[2px] flex h-5 min-w-5 items-center justify-center rounded-full border-2 border-fill-background bg-fill-danger px-1 text-[10px] font-semibold leading-none text-white">
                {unreadNotifications > 99 ? "99+" : unreadNotifications}
              </span>
            ) : null}
          </button>
        </div>
      </div>

      <div className={cn("px-4", isMobile ? "pt-[58px]" : "pt-[56px]")}>
        {/* <ActiveOrderCard /> */}
        <Card className="mt-4 shadow-none border-none rounded-2xl p-2 ">
          {/* Самовывоз временно отключён: табы «Доставка/Самовывоз» закомментированы,
              на экране остаётся только строка адреса доставки. Чтобы вернуть —
              раскомментировать блок ниже и убрать одиночный delivery-ряд. */}
          {/* <Tabs
            value={deliveryTab}
            onValueChange={(value) => {
              impactOccuer("soft");
              dispatch(setFulfillmentMode(value as "delivery" | "pickup"));
            }}
          >
            <TabsList className="relative grid w-full grid-cols-2">
              <div
                className="absolute inset-y-1 left-1 rounded-[8px] bg-fill-base shadow-[0px_2px_16px_0px_#00000014] transition-transform duration-300 ease-out"
                style={{
                  width: "calc(50% - 4px)",
                  transform:
                    deliveryTab === "pickup"
                      ? "translateX(100%)"
                      : "translateX(0%)",
                }}
              />
              <TabsTrigger
                value="delivery"
                className="relative z-10 bg-transparent data-[state=active]:bg-transparent data-[state=active]:shadow-none"
              >
                {t("delivery")}
              </TabsTrigger>
              <TabsTrigger
                value="pickup"
                className="relative z-10 bg-transparent data-[state=active]:bg-transparent data-[state=active]:shadow-none"
              >
                {t("pickup")}
              </TabsTrigger>
            </TabsList>
            <TabsContent value="delivery"> */}
          <div
            className="flex flex-row justify-between items-center px-1"
            onClick={() => {
              impactOccuer("soft");

              // Адрес заводится на аккаунт: гостя сначала на регистрацию.
              if (!user.isAuth) {
                setPendingAddressRedirect(true);
                setIsOpen(true);
                return;
              }

              // With an address saved this is a "switch address" tap; with
              // none it's the same "set your address" flow the order path
              // triggers, so both entry points land on the same screen.
              if (addresses.length > 0) {
                navigate("/profile/addresses");
                return;
              }
              requestCartLocationGate(navigate, { alwaysOpenMap: true });
            }}
          >
            <div className="flex flex-row gap-x-2">
              <div className="w-9 h-9 bg-fill-background rounded-[10px] flex items-center justify-center">
                <DeliveryIcon className="text-text-icon-secondary" />
              </div>
              <div className="flex flex-col gap-y-[2px]">
                <p className="text-body-sm-medium">
                  {truncate(userAddress?.title || t("main.delivery"), 26)}
                </p>
                <p className="text-caption-sm-medium text-text-tertiary">
                  {formatDeliveryTime(deliveryTime ? deliveryTime : 30)}
                </p>
              </div>
            </div>
            <div className="w-6 h-6 rounded-full bg-fill-background flex items-center justify-center">
              <ArrowRightIcon className="text-text-icon-secondary" />
            </div>
          </div>
          {/* </TabsContent>
            <TabsContent value="pickup">
              <div
                className="flex flex-row justify-between items-center px-1"
                onClick={() => {
                  impactOccuer("soft");
                  if (!user.isAuth) {
                    setPendingPickupRedirect(true);
                    setIsOpen(true);
                    return;
                  }
                  navigate("/restaurants/map", { state: { returnTo: "/" } });
                }}
              >
                <div className="flex flex-row gap-x-2">
                  <div className="w-9 h-9 bg-fill-background rounded-[10px] flex items-center justify-center">
                    <ForkIcon className="text-text-icon-secondary" />
                  </div>
                  <div className="flex flex-col gap-y-[2px]">
                    <p className="text-body-sm-medium">
                      {truncate(pickup?.branch?.title || t("pickup"), 26)}
                    </p>
                    <p className="text-caption-sm-medium text-text-tertiary">
                      {pickup?.branch?._id
                        ? truncate(
                            pickup.branch.address || pickup.branch.title,
                            40,
                          )
                        : t("add-pickup")}
                    </p>
                  </div>
                </div>
                <div className="w-6 h-6 rounded-full bg-fill-background flex items-center justify-center">
                  <ArrowRightIcon className="text-text-icon-secondary" />
                </div>
              </div>
            </TabsContent>
          </Tabs> */}
        </Card>
      </div>
      <Stories branchId={contentBranchId} />
      {/* Карта лояльности — вход в QR (макет 1780-3330). Гостю не
          показываем: без аккаунта ни баланса, ни кода не бывает. */}
      {user.isAuth && (
        <div className="px-4 mt-3">
          <LoyaltyCard />
        </div>
      )}
      {/* Кнопки «Акции» и «Промокоды» временно скрыты. Вместе с ними ушёл и
          контейнер: его id — точка интеграции Mindbox, и оставлять её пустой
          смысла нет, раз промо-блок с главной убран целиком. Чтобы вернуть —
          раскомментировать вместе с импортами ActionCard и PromoCard выше.
      <div
        className="grid grid-cols-2 gap-2 px-4 mt-2 mb-2"
        id="mindbox-home-page-promo"
      >
        <ActionCard />
        <PromoCard />
      </div>
      */}

      {isLoadingBanners || banners.length ? (
        <div
          className="flex flex-row overflow-y-auto gap-x-2 "
          style={{ padding: "10px 0 10px 10px" }}
        >
          <BannerCarousel
            banners={banners}
            isLoading={isLoadingBanners}
            menu={menu}
          />
        </div>
      ) : null}

      {!user.isAuth ? (
        <Card className="mx-4 my-2 py-2 px-3 rounded-2xl flex flex-row items-center justify-between">
          <div className="flex flex-col max-w-[220px]">
            <p className="text-body-sm-semibold text-text-primary">
              {t("auth.card.title")}
            </p>
            <p className="text-[12px] font-medium text-text-tertiary">
              {t("auth.card.text")}
            </p>
          </div>
          <Button
            className="rounded-full bg-brand-green shadow-none"
            onClick={() => setIsOpen(true)}
          >
            {t("auth.card.button")}
          </Button>
          <AuthDrawer
            open={open}
            setOpen={(next: boolean) => {
              if (!next) {
                setPendingAddressRedirect(false);
                setPendingNotificationRedirect(false);
              }
              setIsOpen(next);
            }}
            onSuccess={() => {
              if (pendingNotificationRedirect) {
                setPendingNotificationRedirect(false);
                navigate("/notification");
                return;
              }
              if (!pendingAddressRedirect) return;
              setPendingAddressRedirect(false);
              requestCartLocationGate(navigate, { alwaysOpenMap: true });
            }}
            // Единственным сценарием onSuccess был возврат в карту самовывоза.
            // onSuccess={() => {
            //   if (!pendingPickupRedirect) return;
            //   setPendingPickupRedirect(false);
            //   navigate("/restaurants/map", { state: { returnTo: "/" } });
            // }}
          />
        </Card>
      ) : null}

      <div ref={categorySentinelRef} />
      <div
        className={cn(
          "sticky z-40 mt-2",
          !isMobile ? "top-[64px]" : "top-[60px]",
        )}
      >
        <div
          className="absolute inset-0 bg-background pointer-events-none"
          style={{ opacity: shrinkProgress }}
        />
        <div
          ref={categoriesContainerRef}
          className="relative flex flex-row gap-x-2 overflow-x-auto pl-4"
          style={{
            paddingTop: 4 * shrinkProgress,
            paddingBottom: 4 * shrinkProgress,
          }}
        >
          {isLoadingMenu ? (
            <>
              {Array.from({ length: 5 }).map((_, index) => (
                <CategoryCardSkeleton key={index} shrunk={scrolled} />
              ))}
            </>
          ) : null}

          {menu?.map((category, index) => (
            <CategoryCard
              key={index}
              categoryId={category.id}
              img={category.menu[0].category_img}
              txt={
                localized(lang, {
                  ru: category.menu[0].category_title,
                  uz: category.menu[0].category_title_uz,
                  en: category.menu[0].category_title_en,
                })
              }
              progress={shrinkProgress}
              scrollTo={scrollToCategory}
              activeCat={normalizeId(activeCategory)}
            />
          ))}
          <div className="pr-4" />
        </div>
      </div>
      <div className="flex flex-col gap-y-4 px-4">
        {isLoadingMenu ? (
          <FoodSectionSkleton />
        ) : (
          <>
            {menu?.map((item) => (
              <Fragment key={item.id}>
                <div
                  id={`category-${normalizeId(
                    localized(lang, {
                      ru: item.category.title,
                      uz: item.category.title_uz,
                      en: item.category.title_en,
                    }),
                  )}`}
                  className="flex flex-col space-y-2"
                >
                  <p className="text-display-lg font-inter-tight pt-[14px]">
                    {localized(lang, {
                      ru: item.category.title,
                      uz: item.category.title_uz,
                      en: item.category.title_en,
                    })}
                  </p>
                  <PromotionCountdown
                    serverTime={item.category.server_time}
                    endDate={item.category.promotion_end_date}
                  />
                  <div className="w-full">
                    <div className="grid grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-4 ">
                      {item.menu.map((prod, prodIndex) => (
                        <FoodHomeCard
                          key={`${item.id}-${prod.id}-${prodIndex}`}
                          product={prod}
                        />
                      ))}
                    </div>
                  </div>
                  <div ref={ref} className="h-1" />
                </div>
              </Fragment>
            ))}
          </>
        )}
      </div>
      <Drawer
        open={
          user.isAuth && realAddresses && addresses.length > 0 && distance > 50
        }
      >
        <DrawerContent className="px-3 ">
          <DrawerTitle className="text-display-sm text-center pt-4">
            {t("real-address")}
          </DrawerTitle>
          <div className="flex flex-col items-center py-6">
            <p className="text-display-md ">{userAddress?.title}</p>
            <Button
              className="mt-10 w-full h-12 bg-button-primary"
              onClick={() => {
                setRealAddresses(false);
                sessionStorage.setItem("real", "true");
              }}
            >
              {t("yes")}
            </Button>
            <Button
              className="mt-2 w-full h-12 bg-button-secondary"
              onClick={() => {
                navigate("profile/addresses");
                setRealAddresses(false);
                sessionStorage.setItem("real", "true");
              }}
            >
              <p className="text-text-icon-secondary">{t("no")}</p>
            </Button>
          </div>
        </DrawerContent>
      </Drawer>

      <Drawer open={languageDrawerOpen} onOpenChange={setLanguageDrawerOpen}>
        <DrawerContent className="bg-fill-background">
          <div className="px-4 flex flex-row justify-between items-center pb-2">
            <DrawerTitle>
              {LANGUAGE_DRAWER_LABELS[selectedLang]?.title ?? t("language")}
            </DrawerTitle>
            <div
              className="flex items-center justify-center h-6 w-6 rounded-full bg-button-secondary"
              onClick={() => {
                localStorage.setItem("hasChosenLanguage", "true");
                setLanguageDrawerOpen(false);
              }}
            >
              <XIcon className="text-text-icon-secondary" />
            </div>
          </div>
          <div className="px-4 pt-4 pb-5">
            <Card className="flex flex-col rounded-xl pl-4 py-[11px]">
              <div className="flex flex-col space-y-[12px]">
                <div
                  className="flex flex-row items-center justify-between"
                  onClick={() => {
                    setSelectedLang("uz");
                    selectionChanged();
                  }}
                >
                  <p className="text-body-base-regular text-text-primary">
                    O'zbek tili
                  </p>
                  {selectedLang === "uz" && (
                    <div className="pr-[13px]">
                      <CheckIcon className="text-brand-green" />
                    </div>
                  )}
                </div>
                <Separator className="mt-2" />
                <div
                  className="flex flex-row items-center justify-between"
                  onClick={() => {
                    setSelectedLang("ru");
                    selectionChanged();
                  }}
                >
                  <p className="text-body-base-regular text-text-primary">
                    Русский язык
                  </p>
                  {selectedLang === "ru" && (
                    <div className="pr-[13px]">
                      <CheckIcon className="text-brand-green" />
                    </div>
                  )}
                </div>
                <Separator className="mt-2" />
                <div
                  className="flex flex-row items-center justify-between"
                  onClick={() => {
                    setSelectedLang("en");
                    selectionChanged();
                  }}
                >
                  <p className="text-body-base-regular text-text-primary">
                    English
                  </p>
                  {selectedLang === "en" && (
                    <div className="pr-[13px]">
                      <CheckIcon className="text-brand-green" />
                    </div>
                  )}
                </div>
              </div>
            </Card>
          </div>
          <div className="w-full px-4 pb-7">
            <Button
              className="h-12 w-full bg-button-primary rounded-xl"
              onClick={changeLanguage}
            >
              <p className="text-body-base-semibold text-text-white">
                {LANGUAGE_DRAWER_LABELS[selectedLang]?.save ?? t("save")}
              </p>
            </Button>
          </div>
        </DrawerContent>
      </Drawer>

      <UnavailableItemsDrawer
        open={unavailableListOpen}
        setOpen={setUnavailableListOpen}
        items={unavailableItems}
        replacements={replacements}
        activeCartKey={replacingCartKey}
        onChange={handleReplaceItem}
        onRemove={handleRemoveUnavailable}
        onRemoveAll={handleRemoveAllUnavailable}
      />
    </div>
  );
};

export default Home;
